(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px) and (pointer: fine)');

  const closeOtherMenus = (current) => {
    document.querySelectorAll('header details.mega-menu[open]').forEach((item) => {
      if (item !== current) {
        item.removeAttribute('open');
      }
    });
  };

  const initMegaHover = () => {
    document.querySelectorAll('header details.mega-menu').forEach((menu) => {
      if (menu.dataset.cvHoverReady === 'true') return;

      menu.dataset.cvHoverReady = 'true';

      let closeTimer;

      menu.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;

        clearTimeout(closeTimer);
        closeOtherMenus(menu);
        menu.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', () => {
        if (!desktopQuery.matches) return;

        closeTimer = setTimeout(() => {
          menu.removeAttribute('open');
        }, 120);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initMegaHover);
  document.addEventListener('shopify:section:load', initMegaHover);
})();